"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var _overlay = _interopRequireDefault(require("./overlay"));
var _dialogContainer = _interopRequireDefault(require("./dialogContainer"));
var _dialog = _interopRequireDefault(require("./dialog"));
var _header = _interopRequireDefault(require("./header"));
var _closeButton = _interopRequireDefault(require("./closeButton"));
var _body = _interopRequireDefault(require("./body"));
var _footer = _interopRequireDefault(require("./footer"));
const baseStyle = props => ({
  overlay: _overlay.default,
  dialogContainer: _dialogContainer.default,
  header: (0, _header.default)(props),
  dialog: (0, _dialog.default)(props),
  closeButton: (0, _closeButton.default)(props),
  body: (0, _body.default)(props),
  footer: _footer.default
});
const sizes = {
  sm: {
    dialog: {
      // Would have preferred object syntax here and below, but wasn't working for whatever reason
      maxWidth: ['100%', '100%', '48%', '32%', '24%'],
      maxHeight: ['100%', '100%', '60%', '48%', '32%'],
      minHeight: ['auto', 'auto', '32%', '32%', '24%']
    }
  },
  md: {
    dialog: {
      maxWidth: ['100%', '100%', '84%', '60%', '48%'],
      maxHeight: ['100%', '100%', '96%', '84%', '60%'],
      minHeight: ['auto', 'auto', '84%', '60%', '48%']
    }
  },
  lg: {
    dialog: {
      maxWidth: ['100%', '100%', '96%', '84%', '72%'],
      maxHeight: ['100%', '100%', '96%', '96%', '84%'],
      minHeight: ['auto', 'auto', '96%', '84%', '72%']
    }
  }
};
var _default = exports.default = (0, _merge.default)(_theme.default.components.Modal, {
  baseStyle,
  sizes
});